<template>
  <div class="h-full overflow-y-auto p-16 bg-gray-100">
    <base-button theme="gray" class="mb-12" @click="$router.back()">
      &larr; Back
    </base-button>
    <h1 class="text-2xl font-bold mb-12">My account</h1>
    <section>
      <h2 class="text-xl mb-4">My companies</h2>
      <div v-if="fetchingCompanies" class="text-center text-blue-400 my-8">
        <base-loading class="block text-3xl" />
        Loading
      </div>
      <ul v-else class="mb-8">
        <li
          v-for="role in roles"
          :key="role.id"
          class="flex justify-between bg-white mb-1 py-2 px-4"
        >
          <div>{{ role.name }}</div>
          <div>
            <strong>{{ role.role }}</strong>
            <base-button
              v-if="!role.accepted"
              @click="acceptInvitation(role)"
              class="ml-4"
            >
              accept
            </base-button>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: mapState({
    roles: (state) =>
      state.auth.userRoles.map((role) => {
        const storeCompany = state.company.list.find(
          (c) => c.id === role.company
        );
        return {
          ...role,
          name: storeCompany.name,
        };
      }),
    fetchingCompanies: (state) => state.company.fetchingList,
  }),
  methods: {
    acceptInvitation(role) {
      this.$api.patch(`user_company_roles/${role.id}/`, {
        accepted: true,
      });
    },
  },
};
</script>
